import {Comment, DeleteCommentParameter} from '@domain/shifthandover'
import {UseMutationResult} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../consts'
import {ErrorDialog, ConfirmationDialog} from '../dialogs'

type CommentDeleteProps = {
  commentId: string
  onClose: () => void
  deleteCommentAction: UseMutationResult<Comment, AxiosError, DeleteCommentParameter, unknown>
}

export const CommentDelete: React.FC<CommentDeleteProps> = ({
  commentId,
  onClose,
  deleteCommentAction
}) => {
  const {t} = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)

  return (
    <>
      {deleteCommentAction.error ? (
        <ErrorDialog
          httpCode={deleteCommentAction.error.code}
          statusCode={deleteCommentAction.error?.response?.status}
          onClose={() => {
            onClose()
            deleteCommentAction.reset()
          }}
          errorText={deleteCommentAction.error.message}
        />
      ) : (
        <ConfirmationDialog
          onDeleteSingle={() => {
            onClose()
            deleteCommentAction.mutate({commentId})
          }}
          onClose={onClose}
          isSingleLoading={deleteCommentAction.isPending}
          text={t('shiftEvent.sureToDeleteComment')}
          isSeriesItem={false}
        />
      )}
    </>
  )
}
